// Lifecycle
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
export function postResizeMessage(data) {
    postMessage(_object_spread({
        type: "PD_PLACEMENT_RESIZE"
    }, data));
}
export function postCartCheckoutClicked(data) {
    postMessage(_object_spread({
        type: "PD_CART_CHECKOUT_BUTTON_CLICKED"
    }, data));
}
export function postCloseCartClicked(data) {
    postMessage(_object_spread({
        type: "PD_CART_CLOSE_BUTTON_CLICKED"
    }, data));
}
// Checkout
export function postCheckoutLoaded(data) {
    postMessage(_object_spread({
        type: "CHECKOUT_LOADED"
    }, data));
}
export function postPreorderCheckoutStep(checkoutViewModel, step) {
    postMessage(_object_spread({
        type: "PREORDER_CHECKOUT_STEP"
    }, step, toTrackingCheckoutObject(checkoutViewModel)));
}
export function postPreorderCheckoutSubmitted(data) {
    postMessage(_object_spread({
        type: "PREORDER_CHECKOUT_SUBMITTED"
    }, data));
}
export function postPreorderCreated(data) {
    postMessage(_object_spread({
        type: "PREORDER_CREATED"
    }, data));
}
export function postOrderCreated(data) {
    postMessage(_object_spread({
        type: "ORDER_CREATED"
    }, data));
}
export function postPreorderFailed(data) {
    postMessage(_object_spread({
        type: "PREORDER_FAILED"
    }, data));
}
export function postClosedMessage(data) {
    postMessage(_object_spread({
        type: "CLOSED"
    }, data));
}
export function postRemovedFromCart(checkoutViewModel) {
    postMessage(_object_spread({
        type: "REMOVED_FROM_CART"
    }, toTrackingCheckoutObject(checkoutViewModel)));
}
// Status
export function postCartCleared() {
    postMessage({
        type: "CART_CLEARED"
    });
}
export function trackOrderCreated(checkoutViewModel) {
    postOrderCreated(toTrackingOrderObject({
        checkoutViewModel: checkoutViewModel,
        type: "order"
    }));
}
export function trackPreorderCreated(checkoutViewModel) {
    postPreorderCreated(toTrackingOrderObject({
        checkoutViewModel: checkoutViewModel,
        type: "preorder"
    }));
}
export function trackCombinedPreorderCreated(checkoutViewModel) {
    postPreorderCreated(toCombinedTrackingOrderObject({
        checkoutViewModel: checkoutViewModel
    }));
}
export function postGoToHomepage() {
    postMessage({
        type: "GO_TO_HOME_PAGE"
    });
}
/**
 * Used to build the tracking order object from checkoutViewModel
 * @param { Object } args
 * @param { Object } args.checkoutViewModel
 * @param { ('order'|'preorder') } args.type='preorder'
 * @returns Object
 */ export function toTrackingOrderObject() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, checkoutViewModel = ref.checkoutViewModel, _type = ref.type, type = _type === void 0 ? "preorder" : _type;
    var ref1, ref2;
    var order = type === "preorder" ? checkoutViewModel.preorder : checkoutViewModel.order;
    var lineItems = type === "preorder" ? (ref1 = checkoutViewModel.preorder) === null || ref1 === void 0 ? void 0 : ref1.lineItems : (ref2 = checkoutViewModel.order) === null || ref2 === void 0 ? void 0 : ref2.lineItems;
    return {
        reference: order.reference,
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        skuId: lineItems[0].sku.id,
        releaseId: lineItems[0].releaseId,
        lineItem: {
            sku: lineItems[0].sku.sku,
            properties: lineItems[0].lineItemProperties
        },
        lineItems: lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties
            };
        }),
        total: {
            amount: order.total.amount,
            currency: order.total.currency
        },
        tax: order.tax,
        shipping: order.shipping,
        discountCode: order.discountCode
    };
}
export function toCombinedTrackingOrderObject() {
    var checkoutViewModel = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).checkoutViewModel;
    return {
        reference: checkoutViewModel.preorder.reference,
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        lineItems: checkoutViewModel.combinedPreorderOrder.lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties,
                purchaseType: lineItem.purchaseType
            };
        }),
        total: checkoutViewModel.combinedPreorderOrder.total,
        tax: checkoutViewModel.combinedPreorderOrder.tax,
        shipping: checkoutViewModel.combinedPreorderOrder.shipping,
        discountCode: checkoutViewModel.combinedPreorderOrder.discountCode
    };
}
export function toTrackingCheckoutObject(checkoutViewModel) {
    var ref, ref1;
    var lineItems = checkoutViewModel.lineItems;
    return {
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        skuId: (ref = lineItems[0]) === null || ref === void 0 ? void 0 : ref.sku.id,
        releaseId: (ref1 = lineItems[0]) === null || ref1 === void 0 ? void 0 : ref1.releaseId,
        lineItem: lineItems[0] && {
            sku: lineItems[0].sku.sku,
            properties: lineItems[0].lineItemProperties
        },
        lineItems: lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties
            };
        }),
        total: {
            amount: checkoutViewModel.total.amount,
            currency: checkoutViewModel.total.currency
        },
        tax: checkoutViewModel.tax,
        shipping: checkoutViewModel.shipping,
        discountCode: checkoutViewModel.discountCode
    };
}
function postMessage(data) {
    window.parent.postMessage(data, "*");
}
